import { initAuthServicePluginFactory } from '@/shared/services/AuthService'

export default initAuthServicePluginFactory({
  withCustomer: true,
})
